// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main_row {
  max-width: 1200px;
  margin: 0 auto;
}
.main_row .main_col {
  display: flex;
}
@media (max-width: 992px) {
  .main_row .main_col {
    margin-bottom: 10px;
  }
  .main_row .main_col:last-child {
    margin-bottom: 0px;
  }
}

.card_item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  min-height: 150px;
  border-radius: 35px;
  padding: 25px 7.5% 20px;
  margin: 10px 10px;
  background: #f6f1ef;
  color: var(--color-black) !important;
  overflow: hidden;
}
.card_item.disabled {
  opacity: 0.5;
}
.card_item__info {
  width: 100%;
  padding: 15px 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.card_item__info__text {
  margin-bottom: 16px;
}
.card_item__info h3 {
  width: 100%;
  font-size: 18px;
  text-transform: uppercase;
  text-align: center;
  text-wrap: balance;
  font-family: AppFontMedium, sans-serif;
}
.card_item__info p {
  width: 100%;
  font-size: 14px;
  line-height: 16px;
  text-align: left;
  color: black;
}
.card_item__info .block_item {
  display: flex;
  align-items: center;
}
.card_item__info .block_item ion-icon {
  margin-right: 5px;
}
.card_item__info .block_item p {
  font-size: 10px;
  color: var(--ion-color-primary);
}
.card_item__info ion-button {
  min-height: 33px;
  font-size: 12px;
  --border-radius: 26px;
  width: 69%;
  border-radius: 26px;
  font-family: AppFontMedium, sans-serif;
  margin: auto;
}
.card_item__image {
  width: 100%;
  border-radius: 35px;
  overflow: hidden;
}
.card_item__image ion-img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.default_img {
  object-fit: contain !important;
  padding: 20px;
}

.date-start {
  color: rgb(157, 157, 157) !important;
  font-size: 12px !important;
  margin-bottom: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/loyalty-components/coupon-items/coupon-items.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,iBAAA;EACA,cAAA;AADD;AAOC;EACC,aAAA;AALF;ACCE;EDGD;IAGE,mBAAA;EAHD;EAIC;IACC,kBAAA;EAFF;AACF;;AAOA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EAEA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EAEA,mBAAA;EACA,oCAAA;EACA,gBAAA;AAND;AAQC;EACC,YAAA;AANF;AASC;EACC,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;AAPF;AAQE;EACC,mBAAA;AANH;AAQE;EACC,WAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sCAAA;AANH;AAQE;EACC,WAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AANH;AAQE;EACC,aAAA;EACA,mBAAA;AANH;AAOG;EACC,iBAAA;AALJ;AAOG;EACC,eAAA;EACA,+BAAA;AALJ;AAQE;EACC,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,UAAA;EACA,mBAAA;EACA,sCAAA;EACA,YAAA;AANH;AASC;EACC,WAAA;EACA,mBAAA;EACA,gBAAA;AAPF;AAQE;EACC,YAAA;EACA,WAAA;EACA,iBAAA;AANH;;AAUA;EACC,8BAAA;EACA,aAAA;AAPD;;AASA;EACC,oCAAA;EACA,0BAAA;EACA,kBAAA;AAND","sourcesContent":["@import '../../../../theme/mixins';\n\n.main_row {\n\tmax-width: 1200px;\n\tmargin: 0 auto;\n\t// gap: 10px ;\n    // display: flex;\n    // justify-content: center;\n    // flex-wrap: wrap;\n\n\t.main_col {\n\t\tdisplay: flex;\n\t\t@include mobile {\n\t\t\tmargin-bottom: 10px;\n\t\t\t&:last-child {\n\t\t\t\tmargin-bottom: 0px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.card_item {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tjustify-content: space-between;\n\n\twidth: 100%;\n\tmin-height: 150px;\n\tborder-radius: 35px;\n\tpadding: 25px 7.5% 20px;\n\tmargin: 10px 10px;\n\n\tbackground: #f6f1ef;\n\tcolor: var(--color-black) !important;\n\toverflow: hidden;\n\n\t&.disabled {\n\t\topacity: 0.5;\n\t}\n\n\t&__info {\n\t\twidth: 100%;\n\t\tpadding: 15px 10px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\t&__text {\n\t\t\tmargin-bottom: 16px;\n\t\t}\n\t\th3 {\n\t\t\twidth: 100%;\n\t\t\tfont-size: 18px;\n\t\t\ttext-transform: uppercase;\n\t\t\ttext-align: center;\n\t\t\ttext-wrap: balance;\n\t\t\tfont-family: AppFontMedium, sans-serif;\n\t\t}\n\t\tp {\n\t\t\twidth: 100%;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 16px;\n\t\t\ttext-align: left;\n\t\t\tcolor: black;\n\t\t}\n\t\t.block_item {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tion-icon {\n\t\t\t\tmargin-right: 5px;\n\t\t\t}\n\t\t\tp {\n\t\t\t\tfont-size: 10px;\n\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t}\n\t\t}\n\t\tion-button {\n\t\t\tmin-height: 33px;\n\t\t\tfont-size: 12px;\n\t\t\t--border-radius: 26px;\n\t\t\twidth: 69%;\n\t\t\tborder-radius: 26px;\n\t\t\tfont-family: AppFontMedium, sans-serif;\n\t\t\tmargin: auto;\n\t\t}\n\t}\n\t&__image {\n\t\twidth: 100%;\n\t\tborder-radius: 35px;\n\t\toverflow: hidden;\n\t\tion-img {\n\t\t\theight: 100%;\n\t\t\twidth: 100%;\n\t\t\tobject-fit: cover;\n\t\t}\n\t}\n}\n.default_img {\n\tobject-fit: contain !important;\n\tpadding: 20px;\n}\n.date-start {\n\tcolor: rgb(157, 157, 157) !important;\n\tfont-size: 12px !important;\n\tmargin-bottom: 0px;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
